import * as React from 'react';
import type { ReactNode } from 'react';
import { useWindowWidthDetection } from '~/Utils/Hooks/useWindowWidthDetection';
import { MediaBreakpoints } from '~/Utils/MediaBreakpoints';
import { StudyModelHorizontalLayout } from './Components/StudyModelLayout.horizontal';
import { StudyModelVerticalLayout } from './Components/StudyModelLayout.vertical';

export type Semesters = 'first' | 'second' | 'both';

export interface BaseSubjectProps {
    code: string;
    points: number;
    semester: Semesters;
}

export interface StudyModelLayoutProps<TSubjectProps extends BaseSubjectProps> {
    subjects: TSubjectProps[];
    renderSubject: (subject: TSubjectProps) => ReactNode;
    noSubjectsMessage: string;
    firstHeading: string;
    secondHeading?: string;
}

export const StudyModelLayout = <TSubjectProps extends BaseSubjectProps>(
    props: StudyModelLayoutProps<TSubjectProps>
) => {
    const { subjects, ...restProps } = props;

    const isBelowDesktop = useWindowWidthDetection({ condition: 'lessThan', breakpoint: MediaBreakpoints.Desktop });
    const filteredSubjects = React.useMemo(() => subjects.filter(subject => subject.points > 0), [subjects]);

    return isBelowDesktop ? (
        <StudyModelVerticalLayout subjects={filteredSubjects} {...restProps} />
    ) : (
        <StudyModelHorizontalLayout subjects={filteredSubjects} {...restProps} />
    );
};
